import {Component} from '@angular/core';
import {DataService} from '../core/data.service';
import {SearchKennel} from '../core/SearchKennel';
import {AuthService} from 'angularx-social-login';
import {HIUser} from '../core/HIUser';
import {Pet} from '../shared/pets/pet';
import {CustomAuthService} from '../auth.service';
import {Booking} from '../core/Booking';

// import { colors } from '../demo-utils/colors';


@Component({
  styleUrls: ['customer.component.scss'],
  templateUrl: 'customer.component.html',
})
export class CustomerComponent {
  about = false;
  okToBook = false;
  kennels: SearchKennel[] = [];
  maxDistance: string;
  longitude: string;
  latitude: string;
  inDate: string;
  outDate: string;
  theuser: HIUser = new HIUser();
  petList: Pet[] = [];
  selectedPets: Pet[] = [];
  constructor (
    private dataService: DataService,
    private authService: AuthService,
    private myAuthService: CustomAuthService,
    ) {
    if (this.theuser != null && this.theuser.pets != null) {
      this.petList = [...this.theuser.pets];
    }
    this.petList.push(new Pet('Cat Pen(1 or more cats sharing)', 'CAT'));
    this.petList.push(new Pet('Dog Pen(1 or more dogs sharing)', 'DOG'));
  }

  findKennels() {
    console.log('Searching for kennels');
    this.dataService.callGet('kennels?maxDistance=' + this.maxDistance + '&latitude=' + this.latitude + '&longitude=' + this.longitude)
      .subscribe(
      (kennels) => this.kennels = kennels,
      (error) =>  console.log(error));
  }


  handlePetSelected(event: any) {
    this.selectedPets.push(event);
    console.log('Selected pet was:' + event);

  }

    checkAvailability() {
      console.log('Checking for availability');
      const booking = new Booking();
      // booking.pets = this.selectedPets;
      booking.dateIn = this.getDateString(this.inDate);
      booking.dateOut = this.getDateString(this.outDate);
      this.dataService.callPost('availability', JSON.stringify(booking))
          .subscribe(
              (result) => {
                if (result.availability) {
                  console.log('Space available');
                  if (this.myAuthService.isLoggedIn()) {
                  this.okToBook = true;
                  }
                  // Can move to Login, or make booking if already logged in.
                } else {
                  this.okToBook = false;
                  console.log('No space free: ' + result.availability);
                }
              },
              (error) =>  console.log(error));
    }

  private getDateString(raw: string) {
    if (!raw || !raw.includes('/')) {
      return raw;
    }
    const split = raw.split('/');
    return split[2] + '-' + split[0] + '-' + split[1];
  }



  makeBooking() {
    console.log('make booking');
  }


}
